import {
  GetMatchingAgencyContent,
  GetMatchingExpertContent,
  GetMatchingExpertRequest,
  GetMatchingHospitalContent,
  GetMatchingHospitalRequest,
  GetMatchingMeAgencyContent,
  GetMatchingMeHospitalContent,
  GetMatchingMeResponse,
  GetMatchingRequest,
  GetMatchingResponse,
  ReviewData,
  GetReviewListResponse,
  PortfolioData,
  GetPortfolioResponse,
  Review,
} from "models/matching";
import request from "./core";

export const getMatchingSearchHospital = ({
  page,
  name,
  department,
}: GetMatchingHospitalRequest) => {
  let params: GetMatchingHospitalRequest & { size: number } =
    name === "" ? { page, size: 12 } : { page, size: 12, name };
  params = department === "" ? { ...params } : { ...params, department };
  return request.get<GetMatchingResponse<GetMatchingHospitalContent>>(
    "/matching/search/hospital",
    {
      params: params,
    }
  );
};

export const getMatchingSearchExpert = ({
  page,
  name,
  experienceLevel,
}: GetMatchingExpertRequest) => {
  let params: GetMatchingExpertRequest & { size: number } =
    name === "" ? { page, size: 12 } : { page, size: 12, name };
  params =
    experienceLevel === "" ? { ...params } : { ...params, experienceLevel };
  return request.get<GetMatchingResponse<GetMatchingExpertContent>>(
    "/matching/search/expert",
    {
      params: params,
    }
  );
};

export const getMatchingSearchAgency = ({
  page,
  agencyName,
  category,
  minPrice,
  maxPrice,
}: GetMatchingRequest) => {
  let params: GetMatchingRequest & { size: number } =
    agencyName === "" ? { page, size: 12 } : { page, size: 12, agencyName };
  params = category === "" ? { ...params } : { ...params, category };
  params = minPrice !== undefined ? { ...params, minPrice } : { ...params };
  params = maxPrice !== undefined ? { ...params, maxPrice } : { ...params };

  return request.get<GetMatchingResponse<GetMatchingAgencyContent>>(
    "/user/agency",
    {
      params: params,
    }
  );
};

export const postMatchingHospital = (
  userId: GetMatchingHospitalContent["userId"]
) => {
  return request.post("/matching/hospital", { userId });
};

export const postMatchingAgency = (
  userId: GetMatchingAgencyContent["userId"]
) => {
  return request.post("/matching/agency", { userId });
};

export const getMatchingMeHospital = ({
  page,
}: Omit<GetMatchingRequest, "name">) => {
  return request.get<GetMatchingMeResponse<GetMatchingMeHospitalContent>>(
    "/matching/me/hospital",
    {
      params: { page, size: 6 },
    }
  );
};

export const getMatchingMeAgency = ({
  page,
}: Omit<GetMatchingRequest, "name">) => {
  return request.get<GetMatchingMeResponse<GetMatchingMeAgencyContent>>(
    "/matching/me/agency",
    {
      params: { page, size: 6 },
    }
  );
};

export const deleteMatching = ({ id }: { id: number }) => {
  return request.delete("/matching", { data: { matchingId: id } });
};

export const patchMatchingExposed = ({ isExposed }: { isExposed: boolean }) => {
  return request.patch("/users/me/matching/exposed", {
    isExposed,
  });
};

export const getMatchingExposed = () => {
  return request.get<{ isExposed: boolean }>("/users/me/matching/exposed");
};

export const getAgencyDetail = (agencyId: number) => {
  return request.get<GetMatchingAgencyContent>(`/user/agency/${agencyId}`);
};

export const postAgencyReview = (data: ReviewData) => {
  return request.post("/review", data);
};
export const getReviewList = (agencyId: number, page: number) => {
  return request.get<GetReviewListResponse>(`/review/${agencyId}/list`, {
    params: {
      page,
    },
  });
};

export const postPortfolioRegister = (data: PortfolioData) => {
  return request.post("/portfolio", data);
};
export const putPortfolioUpdate = async ({
  id,
  data,
}: {
  id: number;
  data: PortfolioData;
}) => {
  return request.put(`/portfolio/${id}`, data);
};

export const getPortfolioList = (agencyId: number, page: number) => {
  return request.get<GetPortfolioResponse>(`/portfolio/agency/${agencyId}`, {
    params: {
      page,
    },
  });
};
export const deletePortfolio = async (id: number) => {
  console.log("deletePortfolio API 호출, ID:", id);
  try {
    const res = await request.delete(`/portfolio/${id}`);
    console.log("deletePortfolio API 응답:", res);
    return res;
  } catch (err) {
    console.error("deletePortfolio API 에러:", err);
    // 204 No Content는 성공이므로 에러가 아닌 경우 처리
    if (err === undefined || err === null) {
      console.log("204 No Content - 삭제 성공");
      return { success: true };
    }
    throw err;
  }
};

export const getRecentReview = async (): Promise<Review[]> => {
  const res = await request.get<Review[]>("/review/recent");
  return res;
};

export const getRecentPortfolio = async (): Promise<GetPortfolioResponse> => {
  const res = await request.get<GetPortfolioResponse>("/portfolio/list");
  return res;
};

export const toggleAgencyBookmark = async (agencyId: number) => {
  return request.post(`/user/agency/${agencyId}/bookmark`);
};

export const getBookmarkedAgencies = async () => {
  return request.get<GetMatchingAgencyContent[]>("/user/agency/user/bookmark");
};
